(() => {
  'use strict';

  /*
   * PeerNest Student Dashboard
   * Independent section router
   *
   * This intentionally does NOT depend on
   * pn-student-dashboard.js.
   */

  function dashboard() {
    return document.querySelector(
      '[data-pnauth-dashboard][data-role="student"]'
    );
  }


  function openSection(
    name,
    updateHash = true
  ) {

    const root =
      dashboard();

    if (!root) {
      return false;
    }


    const sections =
      Array.from(
        root.querySelectorAll(
          '[data-pndash-section]'
        )
      );


    const links =
      Array.from(
        root.querySelectorAll(
          '[data-pndash-section-link]'
        )
      );


    const target =
      sections.find(
        section =>
          section.dataset.pndashSection ===
          name
      );


    if (!target) {
      return false;
    }


    /*
     * Hide every dashboard section except target.
     */
    sections.forEach(
      section => {

        const active =
          section === target;


        if (active) {

          section.removeAttribute(
            'hidden'
          );

        }
        else {

          section.setAttribute(
            'hidden',
            ''
          );

        }


        section.classList.toggle(
          'is-active',
          active
        );

      }
    );


    /*
     * Overview-only content.
     */
    root
      .querySelectorAll(
        '[data-pndash-overview-only]'
      )
      .forEach(
        item => {

          item.hidden =
            name !==
            'overview';

        }
      );


    /*
     * Sidebar active state.
     */
    links.forEach(
      link => {

        const active =
          link.dataset
            .pndashSectionLink ===
          name;


        link.classList.toggle(
          'is-active',
          active
        );


        if (active) {

          link.setAttribute(
            'aria-current',
            'page'
          );

        }
        else {

          link.removeAttribute(
            'aria-current'
          );

        }

      }
    );


    if (updateHash) {

      history.replaceState(
        null,
        '',
        '#' + name
      );

    }


    return true;

  }


  function openCurrentHash() {

    const requested =
      window.location.hash
        .replace(
          '#',
          ''
        )
        .trim();


    const root =
      dashboard();

    if (!root) {
      return;
    }


    const exists =
      requested
      &&
      root.querySelector(
        `[data-pndash-section="${CSS.escape(
          requested
        )}"]`
      );


    openSection(
      exists
        ? requested
        : 'overview',
      false
    );

  }


  function boot() {

    const root =
      dashboard();

    if (!root) {
      return;
    }


    /*
     * Capture-phase listener.
     *
     * This runs before the older dashboard
     * navigation listeners.
     */
    document.addEventListener(
      'click',
      event => {

        const link =
          event.target.closest(
            '[data-pndash-section-link]'
          );


        if (
          !link
          ||
          !root.contains(
            link
          )
        ) {
          return;
        }


        const name =
          link.dataset
            .pndashSectionLink;


        if (!name) {
          return;
        }


        event.preventDefault();
        event.stopPropagation();


        openSection(
          name,
          true
        );

      },
      true
    );


    openCurrentHash();

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      boot,
      {
        once:true
      }
    );

  }
  else {

    boot();

  }


  window.addEventListener(
    'hashchange',
    openCurrentHash
  );


  window.addEventListener(
    'pageshow',
    openCurrentHash
  );


  /*
   * Expose only for PeerNest internal use.
   */
  window.PeerNestStudentRouter = {
    openSection
  };

})();
